import { configureStore } from "@reduxjs/toolkit";
import trnAppSlice from "./features/trnAppSlice";

export const store = configureStore({
  reducer: {
    trn: trnAppSlice,
  },
});
